module.exports = __webpack_public_path__ + "img/sankaku_45_blue.cf105da9.png";